import { render, staticRenderFns } from "./resoluciones.vue?vue&type=template&id=1d76a7be&scoped=true"
import script from "./resoluciones.vue?vue&type=script&lang=js"
export * from "./resoluciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d76a7be",
  null
  
)

export default component.exports